module.exports = __webpack_public_path__ + "img/cs1.264e85cc.png";